<template>
  <div>
    <!-- <SectionHeader header="Secondary Authorised Officer" image="uiw-font-person" :active="shouldShow ? true : false" /> -->

    <SectionHeader header="Authorised Officer (2)" image="uiw-font-person" :active="shouldShow ? true : false" />
    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="shouldShow">
      <SubHeader header="Authorised Officer (2)" info="test" dialog="secondaryApplicantInfo" />
      <QForm @submit.prevent="onSubmit">
        <div class="q-pa-xs">
          <InputField
            label="First Name"
            placeholder="First Name"
            v-model="form.firstName"
            :required="true"
            :minLength="2"
            :maxLength="40"
          />
          <InputField label="Last Name" placeholder="Last Name" v-model="form.lastName" :required="true" :minLength="2" :maxLength="40" />
          <InputField label="Email" placeholder="Email" v-model="form.email" type="email" :required="true" :minLength="2" :maxLength="55" />
          <InputField
            v-if="region == 'AU'"
            label="Mobile Number"
            placeholder="Mobile Number"
            v-model="form.phone"
            type="tel"
            :required="true"
            :length="10"
          />
          <InputField
            v-if="region == 'NZ'"
            label="Mobile Number"
            placeholder="Mobile Number"
            v-model="form.phone"
            type="tel"
            :required="true"
            :minLength="9"
            :maxLength="12"
          />
          <br />
          <label class="field-label" v-if="region == 'AU'">Please select the role of the Authorised Officer (2)*</label>
          <div class="row" v-if="region == 'AU'">
            <label class="col-12 col-sm-4">
              <QRadio v-model="form.type" val="director" label="Director" class="full-width" />
            </label>
            <label class="col-12 col-sm-4">
              <QRadio v-model="form.type" val="secretary" label="Company Secretary" class="full-width" />
            </label>

            <!-- redio button removed -->
            <!-- <label class="col-12 col-sm-4">
              <QRadio v-model="form.type" val="other" label="Other" class="full-width" />
            </label> -->
          </div>
          <InputField
            label="Other*"
            placeholder="Other"
            v-model="form.type"
            v-if="!(form.type == 'director' || form.type == 'secretary')"
          />
          <div class="q-px-md q-py-md text-center">
            <QBtn color="primary" type="submit" no-caps :disable="!userInfoComputed" :loading="loading">Continue</QBtn>
          </div>
        </div>
      </QForm>
    </div>
  </div>
</template>

<script>
import { QBtn, QForm, QRadio } from 'quasar';
import { mapState, mapActions } from 'vuex';
import InputField from '../../components/Atoms/InputField';
import SectionHeader from '../../components/Atoms/SectionHeader';
import SubHeader from '../../components/Atoms/SubHeader';
import MutateSelectSecondaryApplicant from '../../graphql/mutations/MutateSelectSecondaryApplicant';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';

export default {
  name: 'NominateSecondary',
  components: { SectionHeader, SubHeader, QBtn, QForm, QRadio, InputField },
  mixins: [MyCustomFunctions],
  props: ['shouldShow'],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    },
    userInfoComputed() {
      if (this.form.firstName && this.form.lastName && this.form.email && this.form.phone && this.form.type)
        return {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          phone: this.form.phone
        };
      return false;
    }
  },
  created() {
    if (this.scoreboard && this.scoreboard.secondaryApplicant) {
      this.form.firstName = this.scoreboard.secondaryApplicant.firstName;
      this.form.lastName = this.scoreboard.secondaryApplicant.lastName;
      this.form.email = this.scoreboard.secondaryApplicant.email;
      this.form.phone = this.scoreboard.secondaryApplicant.phone;
      this.form.type = this.scoreboard.secondaryApplicant.applicantType;
    }
  },
  data: function () {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        type: 'director'
      },
      loading: false
    };
  },
  methods: {
    onSubmit: async function () {
      this.loading = true;

      await this.$apollo
        .mutate({
          mutation: MutateSelectSecondaryApplicant,
          variables: {
            applicantType: this.form.type,
            userInfo: this.userInfoComputed
          }
        })
        .then(async (data) => {
          const secondaryApplicant = data?.data?.selectSecondaryApplicant?.secondaryApplicant
            ? data?.data?.selectSecondaryApplicant?.secondaryApplicant
            : null;

          setTimeout(() => {
            this.$emit('secondaryApplicantCreated', secondaryApplicant);
          });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });

      this.loading = false;
    }
  }
};
</script>
